import _ from 'lodash'
import { isImmutable } from 'immutable'

export const getRootParent = (uid, elements, isAnyRoot = false, isBeforeStrip, prev = []) => {
  const parent = isImmutable(elements) ? elements.getIn([uid, 'parent']) : _.get(elements, [uid, 'parent'])
  if (parent && !prev.includes(uid)) {
    let parentType = isImmutable(elements) ? elements.getIn([parent, 'type']) : _.get(elements, [parent, 'type'])
    if (parentType === 'Strip' && isBeforeStrip) {
      return uid
    }
    if (parentType === 'Strip' || (isAnyRoot && ['DrawerEl', 'Modal'].includes(parentType))) {
      return parent
    } else {
      return getRootParent(parent, elements, isAnyRoot, isBeforeStrip, [...prev, uid])
    }
  } else {
    return null
  }
}
